import { computed, inject, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { ServiceGridItemObject } from '@it2go/types';
import { ServiceTypeEnum } from '@libs/types/src/services/enum/service-type.enum';
import { ServiceDashboardWidgetsService } from '../../../features/service-dashboard/service-dashboard-widgets.service';
import { featureOn } from '../../../../../feature-flag';
import { isOperationAllowedForService } from '../../../features/service-dashboard/service-dashboard-widget-policies';

@Injectable()
export class DashboardPageStore extends ComponentStoreV2Factory {
    private readonly serviceDashboardWidgets = inject(ServiceDashboardWidgetsService);

    currentUserId = this.globalGlobalStore.loggedUserStore.currentUserId();

    services = computed<ServiceGridItemObject[]>(() => this.globalGlobalStore.organizationStore.services());

    private readonly legacyErrorsInFolderAllowed = this.globalGlobalStore.isAllowed('voucherPrescribe.create');
    private readonly legacyLowMedicationAllowed = this.globalGlobalStore.isAllowed('folder.update');
    healthCareServiceIds = computed<string[]>(() => this.services()
        .filter(service => (
            service.type === ServiceTypeEnum.HEALTH_CARE
            && (
                !featureOn.SOCIAL_SERVICE_DASHBOARD
                || isOperationAllowedForService(
                    this.globalGlobalStore.loggedUserStore.rules(),
                    'folder.read',
                    service.id,
                )
            )
        ))
        .map(service => String(service.id)),
    );
    canShowErrorsInFolder = computed(() => this.healthCareServiceIds().length > 0
        && this.legacyErrorsInFolderAllowed(),
    );
    canShowLowMedication = computed(() => featureOn.SOCIAL_SERVICE_DASHBOARD
        || this.legacyLowMedicationAllowed(),
    );

    widgetsData = this.serviceDashboardWidgets.visibleWidgetsData;
    hiddenWidgetNames = this.serviceDashboardWidgets.hiddenWidgetNames;
}
